<template>
  <div class="CoalStore_box">
    <div v-if="!isAdjust">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        ref="form"
        size="small"
      >
        <el-form-item label="">
          <el-select
            v-model="form.coalWarehouseNo"
            placeholder="请输入仓号"
            filterable
          >
            <el-option
              v-for="item in coalBunkerList"
              :key="item.id"
              :label="item.coalWarehouseNo"
              :value="item.coalWarehouseNo"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select
            v-model="form.coalCategoryName"
            placeholder="煤种"
            filterable
          >
            <el-option
              v-for="item in coalTypeList"
              :key="item.coalCategoryNo"
              :label="item.coalCategoryName"
              :value="item.coalCategoryName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="">
          <el-select v-model="form.status" placeholder="状态" filterable>
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="搜索"
            perms="-1"
            @click="getData(true)"
            type="primary"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="getReset"
            type="primary"
          />
        </el-form-item>
      </el-form>
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        size="mini"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          align="center"
          width="120"
          fixed
          label="序号"
        >
        </el-table-column>
        <el-table-column prop="coalWarehouseNo" label="仓号"> </el-table-column>
        <el-table-column prop="coalCategoryName" label="煤种"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="updateTime" label="最后修改时间"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 0">启用</span>
            <span v-if="scope.row.status === 1">停用</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页栏-->
      <div class="toolbar" style="padding: 20px">
        <el-pagination
          background
          layout="total, prev, pager, next"
          @current-change="refreshPageRequest"
          :current-page="pageNo"
          :page-size="pageSize"
          :total="totalSize"
          style="float: right"
        >
        </el-pagination>
      </div>
    </div>
    <!--调整历史-->
    <AdjustHistory v-if="isAdjust" @Adjust="AdjustFun" />
  </div>
</template>
<script>
import KtButton from "@/components/Core/KtButton";

export default {
  props: {
    coalMineNo: {
      type: [String],
      default: 100,
    },
  },
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      loading: false,
      title: "",
      pageNo: 1,
      pageSize: 10,
      form: {
        coalCategoryNo: "", // 煤种
        coalCategoryName: "", // 煤种名称
        status: "",
        coalWarehouseNo: "", // 煤仓编号
      },
      coalTypeList: [],
      coalTypeKqList: [],
      stateList: [
        {
          label: "启用",
          value: 0,
        },
        {
          label: "停用",
          value: 1,
        },
      ],
      tableData: [],
      coalBunkerList: [], // 煤仓list
      isAdjust: false,
      totalSize: 0,
      coalCategoryNo: "", // 煤种编号
    };
  },
  mounted() {
    const _t = this;
    _t.getSelect();
    _t.getSelectMc();
    _t.getData(true);
  },
  methods: {
    // 请求数据
    getData(val) {
      const _t = this;
      if (val) {
        _t.pageNo = 1;
      }
      _t.loading = true;
      const params = {
        pageNo: _t.pageNo,
        pageSize: _t.pageSize,
        operationModule: _t.operationModule,
        coalMineNo: _t.coalMineNo,
      };
      const form = { ..._t.form };
      let index = 0;
      for (let key in form) {
        const val = form[key];
        if (val !== "") {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "operationTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      _t.$api.coalStore.coalcategoryList(params).then((res) => {
        if (res.code === "0") {
          let resData = res.data.dtoList || [];
          resData.forEach((item) => {
            if (item.createTime) {
              item.createTime = _t.formatDateTime(item.createTime.toString());
            }
            if (item.updateTime) {
              item.updateTime = _t.formatDateTime(item.updateTime.toString());
            }
          });
          _t.tableData = resData;
          _t.totalSize = res.data.totalSize;
          _t.loading = false;
        } else {
          _t.loading = false;
          _t.$message({
            message: "查询失败, " + res.message,
            type: "error",
          });
        }
      });
    },
    // 获取所有煤种下拉数据
    getSelect() {
      const _t = this;
      _t.$api.coalModel
        .getAllCoalCategories({ coalMineNo: _t.coalMineNo })
        .then((res) => {
          if (res.code === "0") {
            _t.coalTypeList = res.data.coalCategoryList;
          } else {
            _t.$message({
              message: "煤种下拉数据查询失败, " + res.message,
              type: "error",
            });
          }
        });
    },
    // 获取所有开启的煤种下拉数据
    getSelectKq() {
      const _t = this;
      _t.$api.coalStore
        .getAllEnableCoalCategories({ coalMineNo: _t.coalMineNo })
        .then((res) => {
          if (res.code === "0") {
            _t.coalTypeKqList = res.data.coalCategoryList;
          } else {
            _t.$message({
              message: "煤种下拉数据查询失败, " + res.message,
              type: "error",
            });
          }
        });
    },
    // 获取所有煤仓下拉数据
    getSelectMc() {
      const _t = this;
      _t.$api.coalStore
        .getselectedList({ coalMineNo: _t.coalMineNo })
        .then((res) => {
          if (res.code === "0") {
            _t.coalBunkerList = res.data;
          } else {
            _t.$message({
              message: "煤种下拉数据查询失败, " + res.message,
              type: "error",
            });
          }
        });
    },
   
    // 重置
    getReset() {
      const _t = this;
      _t.form.coalCategoryNo = "";
      _t.form.coalCategoryName = "";
      _t.form.coalWarehouseNo = "";
      _t.form.status = "";
      _t.getData(true);
    },
   
    // 点击调整历史
    getAdjust() {
      const _t = this;
      _t.isAdjust = true;
    },

    // 接受调整历史子组件传回的值
    AdjustFun(val) {
      const _t = this;
      _t.isAdjust = val;
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getData(false);
    },

    // 格式化 日期时间
    formatDateTime(date) {
      //不传date则默认当前时间
      return date.replace(
        /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/g,
        "$1-$2-$3 $4:$5:$6"
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.CoalStore_box {
  .CoalStore_box_title {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 0 0;

    .CoalStore_box_title_desc {
      font-size: 18px;
      font-weight: 600;
    }

    .CoalStore_box_title_cz {
      color: #25aff3;
      cursor: pointer;
    }
  }

  .CoalStore_box_dialog {
    display: flex;
    justify-content: space-around;

    .CoalStore_box_dialog_nr {
      width: 33%;

      div:first-child {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 10px;
      }
    }
  }

  .CoalStore_box_dialog_nr_ts {
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
    font-size: 16px;
  }
}
</style>
<style lang="scss">
.coalStore_diaOne {
  .el-select {
    width: 100%;
  }
}
</style>
